module.exports = __webpack_public_path__ + "static/media/segunda_caracteristica.d5a430d3.png";